import {
	AudioIcon,
	FileIcon,
	ImageIcon,
	VideoIcon,
} from '#app/components/icons'

export default {
	name: 'Media Upload',
	slug: 'media',
	version: '1.0.0',
	icon: <ImageIcon />,
	icons: {
		audio: <AudioIcon />,
		file: <FileIcon />,
		image: <ImageIcon />,
		video: <VideoIcon />,
	},
	fields: [
		{
			name: 'Title',
			slug: 'title',
			required: false,
			type: 'text',
			placeholder: 'Title of this Media',
		},
		{
			name: 'Description',
			slug: 'description',
			required: false,
			type: 'text',
			placeholder: 'Description of this Media',
		},
		{
			name: 'File Type',
			slug: 'fileType',
			required: true,
			hidden: true,
			type: 'select',
			values: ['audio', 'pdf', 'file', 'image', 'video'],
			placeholder: 'The File Type of this Media',
		},
		{
			name: 'File Extension',
			slug: 'fileExtension',
			required: true,
			hidden: true,
			type: 'string',
			placeholder: 'The File Extension of this Media',
		},
		{
			name: 'File Name',
			slug: 'fileName',
			required: false,
			hidden: true,
			type: 'string',
			placeholder: 'The name of the Media File',
		},
		{
			name: 'File Size',
			slug: 'fileSize',
			required: false,
			hidden: true,
			type: 'string',
			placeholder: 'The File Size of this Media in MB',
		},
		{
			name: 'Page Count',
			slug: 'pageCount',
			required: false,
			hidden: true,
			type: 'number',
			placeholder: 'The Page Count of this PDF',
		},
		{
			name: 'ArweaveTXID',
			slug: 'arweaveTxId',
			required: true,
			hidden: true,
			type: 'text',
			placeholder: 'The ArweaveTxId of this Media',
		},
		{
			name: 'Image Web2 URL',
			slug: 'web2URL',
			required: true,
			hidden: true,
			type: 'text',
			placeholder: 'Cached Web2 URL of the instagram screenshot',
		},
	],
	info: 'https://atomicform.faq',
}
